export type CookieConsentChoice = 'accepted' | 'rejected';
export type CookieConsentState = CookieConsentChoice | 'unknown';

export const COOKIE_CONSENT_STORAGE_KEY = 'oblex_cookie_consent_v1';
export const OPEN_COOKIE_SETTINGS_EVENT = 'oblex:open-cookie-settings';

export const getCookieConsentState = (): CookieConsentState => {
  if (typeof window === 'undefined') {
    return 'unknown';
  }

  try {
    const storedValue = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (storedValue === 'accepted' || storedValue === 'rejected') {
      return storedValue;
    }
  } catch {
    return 'unknown';
  }

  return 'unknown';
};

export const setCookieConsentState = (value: CookieConsentChoice): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, value);
    return true;
  } catch {
    return false;
  }
};

export const openCookieSettings = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
};
